import React from 'react';

export const FLAT_CONTRACT_BADGE_LABEL = 'Covered by flat contract';
export const FLAT_CONTRACT_INVOICE_BLOCKED =
  'This visit is covered by a flat contract: it is billed by the contract\'s period invoices and cannot be invoiced on its own. '
  + 'To bill extra work, add a separate job.';

/** Pill on jobs generated from a FLAT_CONTRACT recurring schedule (tracker item 34). */
export function FlatContractBadge() {
  return (
    <span
      className="inline-flex items-center rounded-full bg-purple-50 px-2 py-0.5 text-xs font-semibold text-purple-800 ring-1 ring-purple-200"
      title={FLAT_CONTRACT_INVOICE_BLOCKED}
    >
      {FLAT_CONTRACT_BADGE_LABEL}
    </span>
  );
}
